/* eslint-disable prettier/prettier */
import ExtrasService from "../services/ExtrasService";
import router from "../router";

const getDefaultState = () => ({
  data_consent: {
    id: null,
    trainer_uuid: "",
    teacher_uuid: "",
    student_uuid: "",
    parent_uuid: "",
    date: "",
    signed_for_student: "",
    photo: "",
    consent_given: false,
    recorded_by_trainer_uuid: "",
    created_at: "",
    updated_at: "",
  },
  dataConsents: [],
});

const extras = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    dataConsents(state, val) {
      state.dataConsents = val;
    },
  },
  actions: {
    async GET_DATA_CONSENT(context, type) {
      let data;
      const res = await ExtrasService.fetchDataConsent(type);
      data = res.data.results;

      console.log("getting data consent from db: ", data);
      if (data.length > 0) context.commit("dataConsents", data[0]);
    },
  },
  getters: {},
};

export default extras;
